var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-field",
      class: { "disable-html-component": _vm.missing },
    },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { hidden: !_vm.missing, value: "error" },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "slider-value" }, [_vm._v(_vm._s(_vm.value))]),
      _vm._v(" "),
      _c("el-slider", {
        attrs: {
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          "show-stops": "",
          "format-tooltip": _vm.formatToolTip,
          disabled: _vm.disabled,
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }